import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { Entidad } from '../auth/models/entidad.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class EntidadService extends ApiService {
  public readonly key = 'entidades';

  constructor(http: HttpClient, authService: NbAuthService) {
    super(http, authService);
  }

  getEntidades(): Observable<Entidad[] | null> {
    return of(localStorage.getItem(this.key)).pipe(
      map(entidades => entidades ? JSON.parse(entidades) as Entidad[] : null),
      switchMap(entidades => {
        if (entidades)
          return of(entidades);
        return this.get<Entidad[]>('/api/Entity/GetEntities')
          .pipe(tap(entidades => {
            if (!entidades || !entidades.length)
              return;
            const strEntidades = JSON.stringify(entidades);
            localStorage.setItem(this.key, strEntidades);
          }));
      })
    );
  }

  getLogoEntidad(): Observable<Blob> {
    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    });

    return this.http.get('/api/Entity/GetLogo', {
      headers: this.generateHeaders().append('Cache-Control', 'no-cache, no-store, must-revalidate'),
      responseType: 'blob'
    });
  }

  GetNombreEntidad(): Observable<string | null> {
    return this.get<string>('/api/Entity/GetNombre');
  }

  clear() {
    localStorage.clear();
  }

  GetTipoMoneda(): Observable<TipoMoneda[] | null> {
    return this.get<TipoMoneda[]>('/api/EntidadMoneda/GetEntidadMoneda');
  }
}

export interface TipoMoneda{
  iIDMoneda: number,
  tCodigoAlfa: string,
}
